import type { RootState } from '@/store';

const applicantsSelector = (state: RootState) => state.applicants.applicants;
const selectedApplicantSelector = (state: RootState) => state.applicants.selectedApplicant;
const stateWideApplicantsSelector = (state: RootState) => state.applicants.stateWideApplicants;

export { applicantsSelector, selectedApplicantSelector, stateWideApplicantsSelector };
